export default __webpack_public_path__ + "static/David.Lehman_social-002d2e1c67d2106cd1e3223cfa959e27.jpg";